import { Component } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators, NgForm } from '@angular/forms';
import { PinCheck } from './pin.model';
import { AuthenticationService } from '../services/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertsService } from 'angular-alert-module';
import Swal from 'sweetalert2';

@Component({
  templateUrl: './pin.component.html',
  styleUrls: [ './pin.component.scss' ]
})

export class PinCheckComponent {
  myForm: FormGroup;
  submitted: boolean = false;
  pin: any;

  // Form controls
  Pin = new FormGroup({
    pin: new FormControl(''),
  });

  pin_check: PinCheck = {
    pin: ''
  };

  constructor(private auth: AuthenticationService, private activatedRoute: ActivatedRoute, private router: Router,
              private formBuilder: FormBuilder, private alerts: AlertsService) {}


  ngOnInit() {
    this.myForm = this.formBuilder.group(
    {
    pin: ['', [Validators.required]]
    }
    );
  }
  get f() { return this.myForm.controls; }

  checkpin() {
    this.submitted = true;
    this.auth.checkpin(this.pin_check).subscribe(
      (data) => {
        this.submitted = true;

        if (data.code === 200) {

          this.router.navigateByUrl('/reset_password');
        } else if (data.code === 400) {
            Swal.fire({
              title: 'Alert',
              text: data.failed,
              icon: 'warning',
              showCancelButton: false,
              confirmButtonText: 'OK'
            }).then((result) => {
              if (result.isConfirmed) {
                // this.router.navigateByUrl('/test_scheduler');
              }
            })
          }
        },
      err => {
        console.error(err);
        // alert('Email id does not exist');
      }
    );
  }

  Oncancel() {
      this.router.navigateByUrl('/');
  }

}
